import React from 'react';
import { cn } from './lib/utils';

export const Select = React.forwardRef(function Select(
  { className, children, ...props },
  ref,
) {
  return (
    <div className='relative'>
      <select
        ref={ref}
        className={cn(
          'ui-select h-[var(--button-height)] w-full appearance-none rounded-md border border-solid border-input bg-background px-3 pr-8 text-[length:var(--primary-font-size)] leading-none text-foreground',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <svg
        className='pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden='true'
      >
        <path d='m6 9 6 6 6-6' />
      </svg>
    </div>
  );
});
